import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'moment',
  pure: false
})
export class MomentPipe implements PipeTransform {

  transform(value: any, key?: any): any {
    let format: string;
    const formats: any = {
      dmy: 'DD-MM-YYYY',
      dmyhm: 'DD-MM-YYYY HH:mm',
      dmyhms: 'DD-MM-YYYY HH:mm:ss',
      hms: 'HH:mm:ss'
    };

    if (!value) {
      return value;
    }

    format = formats[key];

    return moment(value).format(format);
  }
}
